import React, { Component } from 'react'
import { Body } from '../Shell/Shell'
import { calculateReceiptItemContainersTotal, calculateReceiptItemsTotal } from 'utilities'
import { Modal } from 'components/Modal/Modal'
import Portal from 'components/Portal/Portal'
import { noop } from 'utilities'
import DownloadIcon from '@tecuity/sos-icons/build/react-icons/download-box'
import { Report } from 'components/MyWorkQueue/ReportsList'
import Markdown from 'components/Markdown/Markdown'
import { BASE_URL } from 'requests'
import {
  getAndSetCartQuantity
} from '../../actions'
import { useDispatch } from 'react-redux'
import './Receipt.scss'

const RECEIPT_PAGE_DOWNLOADS_HEADER = process.env.RECEIPT_PAGE_DOWNLOADS_HEADER

export default class ReceiptPage extends Component {
  render() {
    return (
      <Body className="receipt-wrapper">
        <Receipt />
      </Body>
    )
  }
}

export class ReceiptModal extends React.Component {
  state = {
    isOpened: this.props.isOpened || false
  }
  componentDidUpdate = prevProps => {
    if (prevProps.isOpened === false && this.props.isOpened === true) {
      this.setState({
        isOpened: true
      })
    }
  }
  closeModal = () => {
    this.setState({ isOpened: false })
    this.props.onRequestModalClose()
  }
  render() {
    return (
      <Portal isOpened={this.state.isOpened}>
        <Modal
          hideHeader
          closeModal={this.closeModal}
          modalSize="fullscreen"
          noBackground
          disableEntranceAnimation
          modalBodyClassName="login-modal-body"
          save={noop}
          cancel={noop}
          ref={ref => (this.modal = ref)}
        >
          <Receipt />
        </Modal>
      </Portal>
    )
  }
}

export const Receipt = ({
  animated,
  receiptItems,
  receiptItemContainers,
  downloads,
  groupedDownloads,
  refNum = '',
  isFree,
  additionalProps = {}
}) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(getAndSetCartQuantity())
  }, [])

  const total = (receiptItemContainers ? calculateReceiptItemContainersTotal(receiptItemContainers) : calculateReceiptItemsTotal(receiptItems)).toFixed(2)
  return (
    <div className={`receipt zig-zag ${animated !== false ? 'animated fadeInUp' : ''}`}>
      <div className="success-badge animated zoomIn fast-animation">
        <span className="icon icon-check" />
      </div>
      {!isFree && (
        <a
          download
          href={`${BASE_URL}/api/Report/GetReceiptByCartRefNum/${refNum}`}
          className="receipt-download"
        >
          <div>
            <DownloadIcon alt="Download icon" aria-label="Download icon" /> Download Receipt
          </div>
        </a>
      )}
      <h2>
        {additionalProps.RECEIPT_CONFIRMATION_HEADER_TEXT ||
          `${!isFree > 0 ? 'Payment' : 'Submission'} Successful`}
        {additionalProps.RECEIPT_CONFIRMATION_ADDITIONAL_TEXT && (
          <Markdown
            className="markdown"
            source={additionalProps.RECEIPT_CONFIRMATION_ADDITIONAL_TEXT}
          />
        )}
      </h2>
      {/* <a className="download-link"><span className="icon icon-download"></span> Download Receipt</a> */}
      {!isFree && (
        <React.Fragment>
          <div className="line-items">
            {
              receiptItemContainers ?
              receiptItemContainers.map((container, i) => {
                const mainItem = container.RECEIPT_ITEM_WEB_LIST[0]
                return mainItem ? (
                  <LineItem
                    product={mainItem.DESCR_DISPLAY ? mainItem.DESCR_DISPLAY : mainItem.DESCR}
                    details={container.RECEIPT_ITEM_WEB_LIST.slice(1).map((item, k) => ({
                      description: item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR,
                      price: item.LINE_TOTAL
                    }))}
                    price={mainItem.LINE_TOTAL}
                    key={`${mainItem.REF_NUM}${i}`}
                  />
                ) : null
              })
              :
              receiptItems.map((item, i) => (
                <LineItem
                  product={item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR}
                  details={[]}
                  price={item.LINE_TOTAL}
                  key={`${item.REF_NUM}${i}`}
                />
              ))
            }
          </div>
          <div className="total-row">
            <div className="total-col">
              <label htmlFor="total">Total</label>
              <span id="total">{`$${total}`}</span>
            </div>
          </div>
          <div className="refund-text">
            {total < 0 ? <span>{process.env.REFUND_TEXT}</span> : null}
          </div>
        </React.Fragment>
      )}
      {downloads && downloads.length > 0 && (
        <div className="downloads-wrapper">
          <h2>{RECEIPT_PAGE_DOWNLOADS_HEADER ? RECEIPT_PAGE_DOWNLOADS_HEADER : "Available Downloads"}</h2>
          <div className="flex-column">
            {downloads.map((download, i) => (
              <Report report={download} key={`${download.APP_REPORT_ID}${i}`} animated={false} />
            ))}
          </div>
        </div>
      )}
      {
        groupedDownloads && groupedDownloads.LIST.length > 0 && (
          <div className={`downloads-wrapper download-groups`}>
            <h2>{RECEIPT_PAGE_DOWNLOADS_HEADER ? RECEIPT_PAGE_DOWNLOADS_HEADER : "Available Downloads"}</h2>
            {
              groupedDownloads.LIST.map(group => (
                <div className="flex-column download-group" key={group.GUID}>
                  <h3>{group.DESCR}</h3>
                  {group.STATUS_DESCR ? <p>Status: {group.STATUS_DESCR}</p> : null}
                  {group.WORK_QUEUE_DOCUMENT_LIST.map((download, i) => (
                    <Report report={download} key={`${download.APP_REPORT_ID}${i}`} animated={false} />
                  ))}
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  )
}

const LineItem = ({ product, actions, details, price }) => (
  <div className="line-item">
    <div className="flex-row">
      <div className="details">
        <span className="product">{product}</span>
      </div>
      <div className="price">{`$${parseFloat(price, 10).toFixed(2)}`}</div>
    </div>
    <span className="details">
      {details.map((detail, i) => (
        <span className="detail" key={i}>
          {detail.description}
          <div className="detail-price">
            {`$${parseFloat(detail.price, 10).toFixed(2)}`}
          </div>
        </span>
      ))}
    </span>
    {/* <div className="col-sm-3">
      <button className="btn download-button">
        <div>
          <DownloadIcon/> Download
        </div>
      </button>
      <button className="btn btn-default"><span className="icon icon-star-medium"></span> Certificate</button>
    </div> */}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Checkout/Receipt.js